module.exports = __webpack_public_path__ + "static/media/SegoeUI.d325b454.woff";